<template>
    <button class="btn btn-success btn-block" :title="this.$root.trans.save" @click.once="doStore()"><i class="ti-save"></i></button>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data () {
            return {
            }
        },
        computed:{
        },
        mounted() {

        },
        methods: {
           doStore(){
               this.$emit('doStore');
           }
		},
        watch: {

        },
    }
</script>




